(function(){
  var modal = document.getElementById('jbMapModal');
  if (!modal) return;
  var body = document.getElementById('jbMapModalBody');
  var label = document.getElementById('jbMapModalLabel');
  var closeBtn = document.getElementById('jbMapModalClose');
  var continentSection = document.querySelector('.joeba-continent-map-section');
  var continentMapEl = document.getElementById('joeba-continent-map');
  var continentPlaceholder = null;
  var currentMode = null; // 'continent' | 'city'
  var cityMapInstances = {};

  function invalidateMap(){
    if (window.L && continentMapEl && continentMapEl._leaflet_map) {
      try { continentMapEl._leaflet_map.invalidateSize(); } catch(e){}
    }
    Object.keys(cityMapInstances).forEach(function(k){
      try { cityMapInstances[k].invalidateSize(); } catch(e){}
    });
  }

  // Helper: zoek de Leaflet-instance van de continent-map (window-level + DOM-walk).
  function getContinentMap(){
    if (!window.L || !continentMapEl) return null;
    if (continentMapEl._leaflet_map) return continentMapEl._leaflet_map;
    // Leaflet bewaart vaak _leaflet_id; we zoeken via window.L's bekende instances niet, dus
    // we proberen via een globale referentie die het init-script eventueel zet.
    if (window.__joebaContinentMap) return window.__joebaContinentMap;
    return null;
  }

  // Continent bounds (mirror van init-blok hierboven, voor refit na show).
  var __JB_BOUNDS__ = {
    'europa':        [[34, -12],  [65, 35]],
    'azie':          [[0, 25],    [55, 150]],
    'afrika':        [[-37, -20], [38, 55]],
    'noord-amerika': [[5, -170],  [75, -50]],
    'zuid-amerika':  [[-58, -85], [15, -30]],
    'oceanie':       [[-50, 110], [5, 180]]
  };
  function refitContinent(){
    var m = getContinentMap();
    if (!m || !continentMapEl) return;
    try { m.invalidateSize(true); } catch(e){}
    var c = continentMapEl.getAttribute('data-continent');
    var b = __JB_BOUNDS__[c];
    if (b) { try { m.fitBounds(b, { padding: [20, 20], animate: false }); } catch(e){} }
  }

  function moveContinentInto(){
    if (!continentSection || !continentMapEl) return;
    if (!continentPlaceholder) {
      continentPlaceholder = document.createComment('jb-continent-map-placeholder');
      continentSection.parentNode.insertBefore(continentPlaceholder, continentSection);
    }
    body.innerHTML = '';
    body.appendChild(continentSection);
    continentSection.style.display = 'block';
  }
  function restoreContinent(){
    if (continentSection && continentPlaceholder && continentPlaceholder.parentNode) {
      continentPlaceholder.parentNode.insertBefore(continentSection, continentPlaceholder);
      continentSection.style.display = '';
    }
  }

  function buildCityMap(city, handle){
    body.innerHTML = '<div id="jbCityMap_' + handle + '" style="width:100%;height:100%;"></div>';
    var el = document.getElementById('jbCityMap_' + handle);
    if (!window.L || !el) return;
    // Use cached instance if exists
    if (cityMapInstances[handle]) {
      // Re-create container since we cleared body
      try { cityMapInstances[handle].remove(); } catch(e){}
      delete cityMapInstances[handle];
    }
    var map = L.map(el, { scrollWheelZoom: true, zoomControl: true }).setView([20, 0], 2);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap, &copy; CARTO',
      maxZoom: 19
    }).addTo(map);
    cityMapInstances[handle] = map;
    // Geocode city via Nominatim, then fit country-level bounds voor context
    var titleEl = document.querySelector('.joeba-country-hero__title');
    var country = titleEl ? (titleEl.textContent || '').trim() : '';
    var qCity = encodeURIComponent(city + (country ? ', ' + country : ''));
    var cityReq = fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' + qCity, { headers: { 'Accept-Language': 'nl' } }).then(function(r){ return r.json(); });
    var countryReq = country
      ? fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&featuretype=country&q=' + encodeURIComponent(country), { headers: { 'Accept-Language': 'nl' } }).then(function(r){ return r.json(); })
      : Promise.resolve(null);
    Promise.all([cityReq, countryReq])
      .then(function(results){
        var cityData = results[0], countryData = results[1];
        var cityLat = null, cityLng = null;
        if (cityData && cityData[0]) {
          cityLat = parseFloat(cityData[0].lat); cityLng = parseFloat(cityData[0].lon);
          L.marker([cityLat, cityLng]).addTo(map).bindPopup('<b>' + city + '</b>').openPopup();
        }
        var fitted = false;
        if (countryData && countryData[0] && countryData[0].boundingbox) {
          var bb = countryData[0].boundingbox.map(parseFloat);
          try { map.fitBounds([[bb[0], bb[2]], [bb[1], bb[3]]], { padding: [20,20], animate: false }); fitted = true; } catch(e){}
        }
        if (!fitted && cityLat !== null) { map.setView([cityLat, cityLng], 6); }
        setTimeout(function(){ map.invalidateSize(); }, 50);
      })
      .catch(function(){ setTimeout(function(){ map.invalidateSize(); }, 50); });
  }

  // ===== Landkaart met alle steden als markers =====
  var countryMapInstance = null;
  function geocode(q){
    return fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' + encodeURIComponent(q), { headers: { 'Accept-Language': 'nl' } })
      .then(function(r){ return r.json(); })
      .catch(function(){ return null; });
  }
  function buildCountryMap(country, cities){
    body.innerHTML = '<div id="jbCountryMap" style="width:100%;height:100%;"></div>';
    var el = document.getElementById('jbCountryMap');
    if (!window.L || !el) return;
    if (countryMapInstance) { try { countryMapInstance.remove(); } catch(e){} countryMapInstance = null; }
    var map = L.map(el, { scrollWheelZoom: true, zoomControl: true }).setView([20, 0], 2);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap, &copy; CARTO',
      maxZoom: 19
    }).addTo(map);
    countryMapInstance = map;

    geocode(country).then(function(data){
      if (data && data[0] && data[0].boundingbox) {
        var bb = data[0].boundingbox.map(parseFloat);
        try {
          map.fitBounds([[bb[0], bb[2]], [bb[1], bb[3]]], { padding: [80,80], animate: false });
          if (map.getZoom() > 6) map.setZoom(6);
          map.setZoom(map.getZoom() - 1);
        } catch(e){}
      }
      setTimeout(function(){ map.invalidateSize(); }, 50);
    });

    var pts = [];
    cities.forEach(function(city, i){
      // Nominatim rate limit: gespreide requests
      setTimeout(function(){
        geocode(city + ', ' + country).then(function(d){
          if (!d || !d[0]) return;
          var lat = parseFloat(d[0].lat), lng = parseFloat(d[0].lon);
          var icon = L.divIcon({
            className: 'jb-country-city-marker',
            html: '<span style="display:inline-block;padding:5px 10px;border-radius:999px;background:#0e1b4d;color:#fff;font:600 12px/1 system-ui,sans-serif;border:1.5px solid #d4af37;white-space:nowrap;box-shadow:0 3px 10px rgba(0,0,0,.35)">' + city + '</span>',
            iconSize: null
          });
          L.marker([lat, lng], { icon: icon })
            .addTo(map)
            .bindPopup('<b>' + city + '</b>');
          pts.push([lat, lng]);
          if (pts.length === cities.length && pts.length > 1) {
            try {
              map.fitBounds(pts, { padding: [90, 90], animate: false });
              if (map.getZoom() > 7) map.setZoom(7);
              map.setZoom(map.getZoom() - 1);
            } catch(e){}
          }
          map.invalidateSize();
        });
      }, i * 500);
    });
  }

  function open(mode, opts){
    currentMode = mode;
    if (mode === 'continent') {
      label.textContent = 'Wereldkaart';
      moveContinentInto();
    } else if (mode === 'country') {
      label.textContent = (opts && opts.country) ? opts.country + ' op kaart' : 'Kaart';
      buildCountryMap(opts.country, opts.cities || []);
    } else if (mode === 'city') {
      label.textContent = (opts && opts.city) ? opts.city : 'Kaart';
      buildCityMap(opts.city, opts.handle);
    }
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // Forceer juiste rendering: invalidateSize + refit bounds nadat container zichtbaar is.
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        if (mode === 'continent') refitContinent(); else invalidateMap();
      });
    });
    setTimeout(function(){ if (mode === 'continent') refitContinent(); else invalidateMap(); }, 120);
    setTimeout(function(){ if (mode === 'continent') refitContinent(); else invalidateMap(); }, 350);
    // Window resize trigger helpt Leaflet ook
    setTimeout(function(){ try { window.dispatchEvent(new Event('resize')); } catch(e){} }, 200);
  }
  function close(){
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (currentMode === 'continent') restoreContinent();
    currentMode = null;
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-jb-open-map]');
    if (btn) {
      e.preventDefault();
      var mode = btn.getAttribute('data-jb-open-map');
      if (mode === 'city') {
        open('city', { city: btn.getAttribute('data-jb-city'), handle: btn.getAttribute('data-jb-city-handle') });
      } else if (mode === 'country') {
        var raw = btn.getAttribute('data-jb-cities') || '';
        open('country', {
          country: btn.getAttribute('data-jb-country') || '',
          cities: raw.split('|').map(function(s){ return s.trim(); }).filter(Boolean)
        });
      } else {
        open('continent');
      }
      return;
    }
    if (e.target === modal) close();
  });
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });
})();

/* ===========================================================
   Related-Countries: continent-switcher injector
   - Disabled: gebruiker wil alleen het huidige continent zien,
     zonder continent-keuze blokjes boven de carousel.
=========================================================== */
/* (Removed by request — geen continent-pill rij meer.) */
